// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoSection_root__oBocp","fullScreen":"VideoSection_fullScreen__Xpffm","wrapper":"VideoSection_wrapper__o0bKl","button":"VideoSection_button__0cFHt"};